var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "non-field-filters" }, [
    _vm.placeholder
      ? _c("div", { staticClass: "field has-addons" }, [
          _c("div", { staticClass: "control is-expanded has-icons-left" }, [
            _c("span", { staticClass: "icon" }, [
              _c("i", {
                class: {
                  "fas fa-spinner fa-spin": _vm.isLoading || _vm.isTableLoading,
                  "fas fa-search fa-not-spin": !(
                    _vm.isLoading || _vm.isTableLoading
                  ),
                },
                attrs: { "aria-hidden": "true" },
              }),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchText,
                  expression: "searchText",
                },
              ],
              ref: "searchField",
              staticClass: "input",
              attrs: {
                type: "search",
                placeholder: _vm.placeholder,
                title: _vm.$format(_vm.$gettext("Search: {fields}"), {
                  fields: _vm.placeholder,
                }),
              },
              domProps: { value: _vm.searchText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchText = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                attrs: { type: "button" },
                on: { click: _vm.search },
              },
              [_c("bulma-icon", { attrs: { name: "fas fa-search" } })],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.filters.length > 0
      ? _c("div", { staticClass: "filter-actions" }, [
          _c(
            "div",
            { class: { "filters-container": _vm.showFilters } },
            _vm._l(_vm.filters, function (filter, index) {
              return _c(filter.name, {
                key: index,
                tag: "component",
                staticClass: "inline",
                attrs: {
                  isVisible: true,
                  field: _vm.getFieldForFilter(filter),
                  options: _vm.getFilterOptions(filter),
                  prefix: _vm.prefix,
                },
                on: {
                  filter: (query, callback) =>
                    _vm.onFilter(
                      _vm.getFieldForFilter(filter),
                      query,
                      callback
                    ),
                  active: _vm.onFilterBecomeActive,
                  inactive: _vm.onFilterBecomeInactive,
                },
              })
            }),
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }